import { z } from "zod";

export const deactivateTelemetryForVehiclePayload = z.object({
  vehicleUuid: z.uuid(),
  updatedBy: z.string().optional(),
});

export type DeactivateTelemetryForVehiclePayload = z.infer<
  typeof deactivateTelemetryForVehiclePayload
>;
